import type { Dict } from '../types';
import { en } from './en';

export const kn: Dict = en;
